import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn } from "lucide-react";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cr_admin_token", data.token);
      toast.success("Welcome back, admin!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md bg-white rounded-3xl border border-ink/10 shadow-xl p-8 sm:p-10"
      >
        <div className="flex items-center gap-2 mb-8">
          <Logo size={44} testId="admin-login-logo" />
          <div>
            <p className="font-serif text-xl font-bold text-ink leading-none">Random Rider</p>
            <p className="text-[11px] font-mono uppercase tracking-widest text-terra mt-1">Admin Portal</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-ink/60 mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@randomrider.com" data-testid="admin-login-email-input"
              className="w-full bg-sand border border-ink/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terra/50" />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-ink/60 mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" data-testid="admin-login-password-input"
              className="w-full bg-sand border border-ink/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terra/50" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
            className="w-full flex items-center justify-center gap-2 bg-ink text-sand font-semibold py-3.5 rounded-full hover:bg-terra transition-colors disabled:opacity-60">
            <LogIn size={16} /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <Link to="/" data-testid="admin-login-back-link" className="block text-center mt-6 text-xs text-ink/50 hover:text-terra transition-colors">
          ← Back to website
        </Link>
      </motion.div>
    </div>
  );
}
